import React, { useState } from 'react';
import { Button, Container, Form } from 'react-bootstrap';
import { Toaster, toast } from 'react-hot-toast';
import '../styles/home.css';
import anniversaryBanner from '../assets/aniversariobanner.jpeg';
import logoEnv from '../assets/logo-envvv.png';
import logoNovi from '../assets/logo-noviii.png';
import { LIMITS, todayLocal, validateParticipant } from '../validation/participant';

const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/+$/, '');

const Home = () => {
  const [formData, setFormData] = useState({ nombres: '', cedula: '', numeroFactura: '', fechaCumpleanos: '', contacto: '' });
  const [birthdayParts, setBirthdayParts] = useState({ day: '', year: '' });
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [touched, setTouched] = useState({});
  const [attempted, setAttempted] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const currentDate = todayLocal();
  const currentYear = Number(currentDate.slice(0, 4));
  const birthdayYears = Array.from({ length: currentYear - 1900 + 1 }, (_, index) => currentYear - index);
  const { data: validData, errors } = validateParticipant({ ...formData, aceptaTerminos });
  const fieldError = (name) => serverErrors[name] || ((touched[name] || attempted) ? errors[name] : '');
  const handleBlur = ({ target: { name } }) => setTouched((current) => ({ ...current, [name]: true }));
  const handleChange = ({ target: { name, value } }) => {
    const next = name === 'cedula' || name === 'contacto' ? value.replace(/\D/g, '') : value;
    setFormData((current) => ({ ...current, [name]: next.slice(0, LIMITS[name]) }));
    setServerErrors((current) => ({ ...current, [name]: '' }));
  };
  const handleBirthdayChange = (part, value) => {
    const next = { ...birthdayParts, [part]: value };
    const fechaCumpleanos = next.day && next.year ? `${next.year}-09-${next.day.padStart(2, '0')}` : '';
    setBirthdayParts(next);
    setFormData((current) => ({ ...current, fechaCumpleanos }));
    setServerErrors((current) => ({ ...current, fechaCumpleanos: '' }));
  };
  const focusField = (form, errorFields) => {
    const field = Object.keys(errorFields)[0];
    form.elements.namedItem(field)?.focus();
  };
  const controlProps = (name) => ({
    name, value: formData[name], onChange: handleChange, onBlur: handleBlur,
    maxLength: LIMITS[name], required: true, disabled: sending,
    'aria-invalid': Boolean(fieldError(name)), 'aria-describedby': `${name}-error`,
  });
  const feedback = (name) => (
    <span className="field-error" id={`${name}-error`} aria-live="polite">{fieldError(name)}</span>
  );

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (sending) return;
    setAttempted(true);
    const form = event.currentTarget;
    if (Object.keys(errors).length) { focusField(form, errors); return; }
    setServerErrors({});
    setSending(true);
    try {
      const response = await fetch(`${API_URL}/api/participaciones`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(validData),
      });
      const data = await response.json();
      if (!response.ok) {
        const receivedErrors = data.errors || (response.status === 409 ? { numeroFactura: data.error } : {});
        setServerErrors(receivedErrors);
        throw new Error(data.error || 'No fue posible enviar el formulario.');
      }
      setSubmitted(true);
    } catch (error) { toast.error(error.message); } finally { setSending(false); }
  };
  const registerAnother = () => {
    setSubmitted(false); setFormData({ nombres: '', cedula: '', numeroFactura: '', fechaCumpleanos: '', contacto: '' }); setBirthdayParts({ day: '', year: '' }); setAceptaTerminos(false);
    setTouched({}); setAttempted(false); setServerErrors({});
  };

  return (
    <main className="campaign">
      <Toaster position="top-right" />
      <section className="campaign-hero">
        <div className="hero-copy">
          <div className="brand-logos">
            <div className="novi-logo-wrap"><img src={logoNovi} alt="Novicompu" className="novi-logo" /></div>
            <span className="brand-divider" aria-hidden="true">+</span>
            <div className="env-logo-wrap"><img src={logoEnv} alt="ENV Tech" className="env-logo" /></div>
          </div>

          <h1>NUESTRO ANIVERSARIO<br />LO CELEBRAMOS JUNTOS</h1>
          <p className="hero-lead">Si cumples años en septiembre, celebra con ENV y Novicompu.</p>
        </div>
        <div className="campaign-visual">
          <img
            src={anniversaryBanner}
            alt="Celebra tu cumpleaños con Novicompu y ENV: participa por una chiva fiestera y premios ENV"
            className="campaign-banner"
            loading="eager"
            decoding="async"
          />
        </div>
      </section>
      <Container className="campaign-content">
        {submitted ? (
          <section className="success-card" aria-live="polite">
            <div className="success-icon">✓</div><h2>¡Tu participación está registrada!</h2>
            <p>Gracias por celebrar nuestro aniversario con nosotros. Conserva tu factura para cualquier validación.</p>
            <Button onClick={registerAnother}>Registrar otra participación</Button>
          </section>
        ) : (
          <div className="campaign-grid">
            <section className="details-card">
              <h2>¡Celebramos tu cumple con ENV!</h2>
              <p>Por la compra de cualquier producto ENV en Novicompu podrás participar por una experiencia de cumpleaños diferente.</p>
              <h3>¿Cómo participar?</h3>
              <ol><li>Compra cualquier producto ENV en Novicompu.</li><li>Registra tus datos y los de tu factura.</li><li>Debes cumplir años durante septiembre.</li></ol>
              <h3>¿Qué gana el cumpleañero?</h3>
              <ul>
                <li>Celebración especial de cumpleaños en las oficinas de Novicompu.</li>
                <li>Participación en un LIVE junto al equipo de ENV.</li>
                <li>Pase a la Chiva Cumpleañera ENV el 25 de Septiembre.</li>
                <li>Podrá llevar hasta 5 acompañantes a la chiva.</li>
                <li>Recibirá un Parlante ENV BOOM-PRO 15 W.</li>
                <li>Recibirá una Mochila ENV ElitePack.</li>
              </ul>
            </section>
            <section className="form-card">
              <h2>Participa aquí</h2><p className="form-intro">Completa tus datos para participar.</p>
              <Form className="participation-form" onSubmit={handleSubmit} noValidate aria-busy={sending}>
                <Form.Group controlId="nombres" className="participation-field">
                  <Form.Label>Nombres <span>*</span></Form.Label>
                  <Form.Control {...controlProps('nombres')} autoComplete="name" minLength={2} placeholder="Ingresa tus nombres completos" />
                  {feedback('nombres')}
                </Form.Group>
                <Form.Group controlId="cedula" className="participation-field">
                  <Form.Label>Cédula <span>*</span></Form.Label>
                  <Form.Control {...controlProps('cedula')} type="text" inputMode="numeric" pattern="[0-9]{10}" minLength={10} placeholder="Ingresa los 10 dígitos" />
                  {feedback('cedula')}
                </Form.Group>
                <Form.Group controlId="numeroFactura" className="participation-field">
                  <Form.Label># Factura <span>*</span></Form.Label>
                  <Form.Control {...controlProps('numeroFactura')} placeholder="Ej. 001-001-000123456" />
                  {feedback('numeroFactura')}
                </Form.Group>
                <Form.Group controlId="fechaCumpleanos" className="participation-field">
                  <Form.Label>Fecha de cumpleaños <span>*</span></Form.Label>
                  <div className="birthday-selectors" aria-describedby="fechaCumpleanos-error">
                    <Form.Select id="fechaCumpleanos" name="fechaCumpleanos" value={birthdayParts.day} onChange={(event) => handleBirthdayChange('day', event.target.value)} onBlur={handleBlur} required disabled={sending} aria-invalid={Boolean(fieldError('fechaCumpleanos'))}>
                      <option value="">Día</option>
                      {Array.from({ length: 31 }, (_, index) => <option key={index + 1} value={String(index + 1)}>{index + 1}</option>)}
                    </Form.Select>
                    <span className="birthday-month" aria-label="Mes de cumpleaños: septiembre">Septiembre</span>
                    <Form.Select name="fechaCumpleanosYear" aria-label="Año de nacimiento" value={birthdayParts.year} onChange={(event) => handleBirthdayChange('year', event.target.value)} onBlur={() => handleBlur({ target: { name: 'fechaCumpleanos' } })} required disabled={sending} aria-invalid={Boolean(fieldError('fechaCumpleanos'))}>
                      <option value="">Año</option>
                      {birthdayYears.map((year) => <option key={year} value={String(year)}>{year}</option>)}
                    </Form.Select>
                  </div>
                  {feedback('fechaCumpleanos')}
                </Form.Group>
                <Form.Group controlId="contacto" className="participation-field">
                  <Form.Label>Teléfono <span>*</span></Form.Label>
                  <Form.Control {...controlProps('contacto')} type="tel" inputMode="numeric" pattern="[0-9]{7,15}" minLength={7} placeholder="Ej. 0991234567" autoComplete="tel" />
                  {feedback('contacto')}
                </Form.Group>
                <Form.Group className="terms">
                  <Form.Check id="terms" name="aceptaTerminos" required disabled={sending} checked={aceptaTerminos} aria-invalid={Boolean(fieldError('aceptaTerminos'))} aria-describedby="terms-error"
                    onChange={(event) => { setAceptaTerminos(event.target.checked); setServerErrors((current) => ({ ...current, aceptaTerminos: '' })); }}
                    label={<span>Acepto las <a href="/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">bases, términos y condiciones</a>.</span>} />
                  <span id="terms-error" className="field-error" aria-live="polite">{fieldError('aceptaTerminos')}</span>
                </Form.Group>
                <Button type="submit" disabled={sending}>{sending ? 'Enviando...' : 'Participar'}</Button>
              </Form>
            </section>
          </div>
        )}
      </Container>
      <footer className="campaign-disclaimer">Aplican condiciones y restricciones.</footer>
    </main>
  );
};
export default Home;
